const ScrollTop = () => {
  return (
    <button className="fixed bottom-20 right-10 z-10 bg-primary bg-opacity-25">
      <img className="w-14 rotate-180 transform p-4" src="/images/ic-expand-wh.svg" alt="" />
    </button>
  );
};

export default ScrollTop;
